import { EarningsTracker } from '@/components/dashboard/EarningsTracker';

export default function HostEarnings() {
  return <EarningsTracker />;
}
